export default __webpack_public_path__ + "static/media/state-award-technokasim.117377ac.jpg";